export default "__VITE_ASSET__C8rf2Cs9__"